function presentText(value) {
  return typeof value === "string" && value.trim() ? value : null;
}

// Display-only contract. No excerpt/alt/caption substitutions and no image URL rewrite.
// Subtitle and image labels are plain text, as entered in the article editor.
export function articlePresentation(article = {}) {
  return {
    subtitle: presentText(article.subtitle),
    image: article.image,
    imageAlt: presentText(article.imageAlt) || presentText(article.title) || "",
    imageTitle: presentText(article.imageTitle),
    imageCredit: presentText(article.imageCredit),
  };
}
